module.exports = __webpack_public_path__ + "img/1526749489.f734de9b.jpg";